// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionReportBody.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Input = require('share/components/controls/Izenda.Input');
  var EventsUtils = require('EventUtils');
  var CategoryPermission = require('./Izenda.CategoryPermission');
  var constants = require('logic/data/Izenda.TenantConstants').TENANT_PERMISSIONS.REPORT.CATEGORY_ACCESSIBILITY;
  var PermissionConstants = require('logic/data/Izenda.PermissionConstants');
  var UNCHECK_VALUE = 0;
  
  var PermissionReportBody = React.createClass({
    propTypes: {
      permission: React.PropTypes.object.isRequired
    },

    componentWillMount: function () {
      var permissionStore = this.props.permissionStore;
      this.reports = this.props.permission.reports;
      this.afterSwitchTree = permissionStore.updateReportAccessibilityCategory.bind(permissionStore);
    },

    render: function () {
      var notifyChange = EventsUtils.notifyChange;
      var permission = this.props.permission;
      var permissionStore = this.props.permissionStore;
      var tenantDetail = permissionStore.tenantDetail;
      var localization = this.props.localization;

      return (
        !permissionStore.isTenantSetup &&
        <GridLayout >
          <GridLayout.Row className="u_paddingTop u_paddingBottom u_borderBottom u_noMarginAll">
            <GridLayout.Col cols={2} className="izenda-PermissionCategory-SubSubCategory">
              {localization.getText("PERMISSION_LABEL_CATEGORY_ACCESSIBILITY")}
            </GridLayout.Col>
            <GridLayout.Col cols={9}>
              <div className="u_inlineBlock u_fullWidth">
                <CategoryPermission
                  {...this.props}
                  typeName={PermissionConstants.SECTION.Reports}
                  leftHeader={constants.AVAILABLE_TREE_HEADER}
                  rightHeader={constants.SAVABLE_TREE_HEADER}
                  middleHeader={constants.VISIBLE_TREE_HEADER}
                  categoryPermission={this.props.permissionStore.reportCategoryAccessibility}
                  afterSwitchTree={this.afterSwitchTree}
                  />
              </div>
            </GridLayout.Col>
            {permissionStore.isTenantSetup && <GridLayout.Col cols={1} className="u_textCenter">
              <Input type='checkbox'
                readOnly={this.props.readOnly}
                checked={this.props.getCheckedCommon(this.reports.reportCategoriesSubcategories.categoryAccessibility.tenantAccess) }
                onChange={notifyChange(permission.updateTenantAccess.bind(permission, this.reports, this.reports.reportCategoriesSubcategories.categoryAccessibility), EventsUtils.CHECKBOX) } />
            </GridLayout.Col>}
          </GridLayout.Row>
        </GridLayout>
      );
    }
  });

  module.exports = connect()(PermissionReportBody);
} ());



// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/PermissionBody/Izenda.PermissionReportBody.jsx